import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const CardComponent = styled(Card)`
  box-shadow: 5px 5px 8px #3336;
  margin-bottom: 15px;
`
